import type { SVGProps } from 'react';

export function MapPinIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      stroke="currentColor"
      strokeWidth={1.33}
      strokeLinecap="round"
      strokeLinejoin="round"
      {...props}
    >
      <path d="M14 6.67c0 4.66-6 8.66-6 8.66s-6-4-6-8.66a6 6 0 0 1 12 0Z" />
      <circle cx={8} cy={6.67} r={2} />
    </svg>
  );
}
